import { render, staticRenderFns } from "./TinymceEditor.vue?vue&type=template&id=21a58b54&scoped=true&"
import script from "./TinymceEditor.vue?vue&type=script&lang=js&"
export * from "./TinymceEditor.vue?vue&type=script&lang=js&"
import style0 from "./TinymceEditor.vue?vue&type=style&index=0&id=21a58b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a58b54",
  null
  
)

export default component.exports